import PropTypes from 'prop-types';
import { Field } from 'formik';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  field: {
    margin: theme.spacing(1, 0),
  },
  checkbox: {
    paddingTop: 0,
    paddingBottom: 0
  },
  helperText: {
  }
}));

const CheckboxField = ({ name, label, disabled, touched, helperText, className }) => {
  const classes = useStyles();
  return (
    <Field name={name}>
      {({ field, form }) => (
        <FormControl
          error={(touched || form.touched[field.name]) && Boolean(form.errors[field.name])}
          className={clsx(classes.field, className)}
        >
          <FormControlLabel
            control={(
              <Checkbox
                id={name}
                {...field}
                value={true}
                checked={field.value}
                classes={{ root: classes.checkbox }}
              />
            )}
            label={label}
            disabled={disabled}
          />
          {(((touched || form.touched[field.name]) && form.errors[field.name]) || helperText) && (
            <FormHelperText className={classes.helperText}>
              {((touched || form.touched[field.name]) && form.errors[field.name]) || helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    </Field>
  );
};

CheckboxField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  helperText: PropTypes.string,
  className: PropTypes.string
};

export default CheckboxField;
